module Meevo.Components.Controls {
    import CoSearchType = Meevo.Model.CoSearchType;
    "use strict";

    export class InventoryMaintenanceFormSideBar {
        private itemsPerPage: number = 1000;
        private securityParts = Meevo.Components.Common.SecurityParts;
        private newItems: any;

        restrict = "E";
        templateUrl = 'app/components/controls/inventoryMaintenanceFormSideBarTemplate.html';

        scope = {
            ngModel: "=",
            baseEndpoint: "@",
            filterTemplateUrl: "@",
            itemTemplateUrl: "@",
            headerTemplateUrl: "@",
            visualState: "=",
            searchContext: "=",
            searchContextCriteria: "=",
            searchFallbackCriteria: "=",
            selectedItemId: "=",
            initialEditSection: "=",
            asLocationId: "=?",
            disableCrud: "=",
            view: "=",
            advancedSearchTemplate: "@",
            advancedSearchMobileTemplate: "@?",
            chipTemplate: "@",
            templateController: "@",
            headerContentKey: "@",
            coSearchTemplate: "@?",
            coMobileSearchFilterTemplate: "@?",
            notificationBeforeAddState: "&?",
            closeWhenStatesUntruthy: "=", // Allows advanced search to close when base criteria filters are untruthy
            noun: "@?", // Noun for Usage Tracking
            displayNameColumnsCustom: "=?",   // custom set of columns
            coColumnsCustom: "=?",   // custom set of columns,
            hideExistsAtColumn: "=?",
            allowAllBusinesstype: "=",
            baseMainKey: "=?",
            customStyle: "=?",
            showResults: "=?",
            showTableHeaderRegardlessOfCommonRules: "=?", // currently table header is shown only in CO mode. The setting allows to show it anyway
            controllerObject: "=?",  // link to the angular controller object. for retrieving additional data.
            postItemRetrievalFunction: "=?",
            coFilterBoolean: "=?", // links to the hideCoFilters which controls wether or not filter headers are shown
            isSearchGlobal: "=?", //used to pass isGlobal search criteria between maintenanceFormSearch and maintenanceForm
            showHeader: "=?",
            addingItem: "=?",
            searchingAddsToExistingItems: "=?",
            isFirstSearch: "=?",
            intelligentSearch: "=?",
            isSideBarOpen: "=?"
        };

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
            scope.criteria = {
                includeActive: true,
                view: scope.view,
                coSearchType: null,
                coBusinessTypeId: null,
                coFilterByLocationId: null,
                coSearchResultFilter: 0,
                location: null,
                businessType: null,
                maintenanceMode: true
            };

            if (angular.isUndefined(scope.topMargin)) {
                scope.topMargin = "";
            }

            if (angular.isUndefined(scope.showResults)) {
                scope.showResults = true;
            }
            if (angular.isUndefined(scope.showHeader)) {
                scope.showHeader = false;
            }

            if (angular.isUndefined(scope.showTableHeaderRegardlessOfCommonRules)) {
                scope.showTableHeaderRegardlessOfCommonRules = false;
            }

            scope.getAddSecurityKey = (): string => {
                return scope.baseMainKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE
            }

            var securityCheck = <Meevo.Components.Common.SecurityService>this.securityService;
            // TODO: Improve this implementation
            securityCheck.checkSecurityKey(scope.getAddSecurityKey())
                .then(response => {
                    scope._showAdd = response === Model.SecurityAccessEnum.Grant;
                });

            scope._showAdd = false;
            scope.showAdd = (): boolean => {
                return scope.isApplicationModeCO()
                    ? (Model.Guard.isNothing(scope.criteria.coSearchType) || scope.criteria.coSearchType === CoSearchType.CentralOffice) && scope._showAdd
                    : scope._showAdd;   
            }
            scope.showSidebar = () => {
                this.$mdSidenav('purchaseOrderSidenav').open();
                setTimeout(() => {
                    scope.$emit('purchaseOrder:isSideBarOpen', true);
                }, 0);
            }
            scope.hideSidebar = () => {
                scope.$emit('purchaseOrder:isSideBarOpen', false);
                this.$mdSidenav('purchaseOrderSidenav').close();
            }

            scope.calcFormWidth = () => {
                return {
                    "width": `${angular.element(document).find('body')[0].clientWidth - 18}px`
                };
            }

            /**
            * Determines whether the application is in CO mode
            */
            scope.isApplicationModeCO = (): boolean => {
                return this.identityService.inCentralOfficeMode();
            }

            scope.isUserHasBusinessTypeIds = (): boolean => {
                return scope.isApplicationModeCO()
                    && this.identityService.isUserHasBusinessTypeIds();
            }
            if (scope.isApplicationModeCO() || scope.showTableHeaderRegardlessOfCommonRules) {
                //scope.criteria.coSearchType = CoSearchType.CentralOffice;
                // Build DisplayName sortable columns
                scope.displayNameColumn = scope.displayNameColumnsCustom
                    ? scope.displayNameColumnsCustom
                    : { header: "Display Name", fieldName: 'DisplayName', sortDirection: Model.SortDirection.Ascending, width: 20 };
                // Build CO sortable columns
                scope.coColumns = scope.coColumnsCustom
                    ? scope.coColumnsCustom
                    : [
                        { header: "DateCreated", fieldName: 'Date Created', sortDirection: Model.SortDirection.Descending, width: 20 },
                        { header: "Display Name", fieldName: 'DisplayName', sortDirection: null, width: 35 },
                        { header: "Owned By", fieldName: 'OwnedByLocationName', sortDirection: null, width: 20 },
                        { header: "Products", fieldName: 'Products', sortDirection: null, width: 25 }
                    ];

            }
            scope.loggedInUserId = { UserID: this.identityService.loggedInUserId() };

            scope.columnSort = (header: string): void => {
                if (Model.Guard.isSomething(header)) {
                    // Prepare target sorting column
                    if (scope.displayNameColumn.header === header) {
                        scope.toggleSortColumn(scope.displayNameColumn);
                        scope.selectedSortColumn = scope.displayNameColumn;
                    }
                    else {
                        var column = _.find(scope.coColumns, (c: any) => c.header === header);
                        scope.toggleSortColumn(column);
                        scope.selectedSortColumn = column;
                    }
                }
                // Invoke search wih sorted column
                if (Model.Guard.isSomething(scope.selectedSortColumn)) {
                    scope.search();
                }
            }

            // Can be used to clear columns
            scope.resetColumns = (): void => {
                scope.displayNameColumn.sortDirection = null;
                _.forEach(scope.coColumns, (c: any) => c.sortDirection = null);
            }

            scope.toggleSortColumn = (column: any): void => {
                if (Model.Guard.isSomething(column)) {
                    if (column.sortDirection === Model.SortDirection.Ascending)
                        column.sortDirection = Model.SortDirection.Descending
                    else
                        column.sortDirection = Model.SortDirection.Ascending
                }
            }

            scope.selectedSortColumn = null;

            if (Model.Guard.isSomething(scope.searchContextCriteria)) {
                // Applies custom criteria
                scope.criteria = scope.searchContextCriteria;
                // Ensures criteria is truthy
                scope.criteria.includeActive = true;
                scope.criteria.view = scope.view;
            }

            //scope.intelligentSearch = "";
            scope.showAdvanced = false;

            let translate = this.$translate;

            //angular.element('#maint_form_search_container .virtualRepeatdemoInfiniteScroll #vertical-container').css('height', (angular.element('.main-content-container').height() - 185).toString());
            //angular.element(window).on('resize', function () {
            //  scope.$apply(function () {
            //    angular.element('#maint_form_search_container .virtualRepeatdemoInfiniteScroll #vertical-container').css('height', (angular.element('.main-content-container').height() - 185).toString());
            //  })
            //});

            scope.add = (): void => {
                scope.selectedItemId = null;
                // Handle add hook implementation
                if (_.isFunction(scope.notificationBeforeAddState)) {
                    scope.processNotificationBeforeAddState();
                } else {
                    scope.visualState = Model.MaintenanceFormVisualState.Detail;
                }
                scope.trackUsage(Model.VerbEnum.Created, scope.criteria);
            }

            scope.processNotificationBeforeAddState = (): void => {
                scope.suppressSearch = true;
                scope.notificationBeforeAddState()
                    .then(result => {
                        scope.visualState = Model.MaintenanceFormVisualState.Detail;
                    })
                    .finally(() => { scope.suppressSearch = false; });
            }

            scope.detail = (id: Guid, atLocationId: number): void => {
                scope.asLocationId = atLocationId;
                scope.selectedItemId = id;
                if (scope.items && scope.items.loadedPages) {
                    scope.searchContext = scope.items.loadedPages[0];
                } else {
                    scope.searchContext = [];
                }
                // Need to clear this out in case user wants to search from the same context. FOR CLIENT CONTEXT
                if (scope.initialEditSection)
                    scope.initialEditSection = undefined;
                scope.visualState = Model.MaintenanceFormVisualState.Detail;
            }

            /* START: Infinite Scroll Data Retrieval */

            scope.toggleShowAdvanced = (): void => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    preserveScope: true,
                    scope: scope,
                    templateUrl: scope.advancedSearchTemplate,
                    controller: scope.templateController,
                    controllerAs: "vm",
                    escapeToClose: false,
                    clickOutsideToClose: false,
                    locals: {}
                }
                this.modalService.showCustom(options);

            }

            scope.toggleCoMenu = (): void => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    preserveScope: true,
                    scope: scope,
                    templateUrl: scope.coSearchTemplate,
                    controller: scope.templateController,
                    controllerAs: "vm",
                    escapeToClose: false,
                    clickOutsideToClose: false,
                    locals: {}
                }
                this.modalService.showCustom(options);

            }

            scope.businessTypeCriteria = { IncludeAllLocationsListItem: Model.Guard.isNothing(scope.allowAllBusinesstype) ? true : scope.allowAllBusinesstype };

            if (scope.postItemRetrievalFunction) {
                scope.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint, scope.postItemRetrievalFunction, scope.searchContext);
            } else {
                scope.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint);
            }

            if (scope.postItemRetrievalFunction) {
                scope.newItems = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint, scope.postItemRetrievalFunction, scope.searchContext);
            } else {
                scope.newItems = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint);
            }

            scope.getRequest = function (pageNum, itemsPerPage) {
                var applyColumnSorting = Model.Guard.isSomething(scope.selectedSortColumn);
                return {
                    pageNumber: pageNum,
                    itemsPerPage: itemsPerPage,
                    criteria: scope.criteria,
                    sortBy: applyColumnSorting ? scope.selectedSortColumn.fieldName : null,  // default should be null so it can be used as the stored procs default
                    sortDirection: applyColumnSorting ? scope.selectedSortColumn.sortDirection : Model.SortDirection.Ascending,
                    asLocationId: scope.locationId
                };
            }

            scope.search = (): void => {
                if (scope.criteria.isGlobal) {
                    scope.isSearchGlobal = true;
                }
                else {
                    scope.isSearchGlobal = false;
                }

                if (scope.suppressSearch)
                    return;
                scope.hideCoFilters = true;
                scope.showCo = false;
                if (scope.maintenanceSearchForm.$valid) {

                    if (!(scope.criteria.location == null || scope.criteria.location.id === undefined || scope.criteria.location.id == null || scope.criteria.location.id.length <= 0)) {
                        scope.criteria.coFilterByLocationId = scope.criteria.location.id;
                    }
                    else {
                        scope.criteria.coFilterByLocationId = null;
                    }

                    if (!(scope.criteria.businessType == null || scope.criteria.businessType.id === undefined || scope.criteria.businessType.id == null || scope.criteria.businessType.id.length <= 0)) {
                        scope.criteria.coBusinessTypeId = scope.criteria.businessType.id;
                    }
                    else {
                        scope.criteria.coBusinessTypeId = null;
                    }

                    if (scope.areStatesUntruthy() && scope.isCloseWhenStatesUntruthySpecified()) {
                        scope.clearAdvancedSearchAndApply();
                        scope.items.clearSearch();
                        //scope.newItems.clearSearch();
                    } else {                     
                        
                        
                        // Always pass criteria and add value into filter
                        // TODO: Refactor out intelligentSearch and just use filter
                        var filterValue = Model.Guard.isSomething(`%${scope.intelligentSearch}%`) ? "%" + scope.intelligentSearch + "%" : null;
                        scope.criteria.filter = filterValue;
                        // Close advanced search
                        scope.closeModal();

                        this.busyService.start();

                        var self = this;
                        var getProducts = function (request) {
                            var defer = self.$q.defer();
                            self.dataService.customMethodData("api/PurchaseOrder/Product/List/", "POST", request)
                            return defer.promise;
                        }

                        scope.products = [];

                        this.dataService.customMethodData("api/PurchaseOrder/Product/Count/", "POST", scope.getRequest(0, this.itemsPerPage))
                            .then((response) => {
                                var totalProducts = response.data;
                                var totalPages = Math.ceil(totalProducts / this.itemsPerPage);
                                                               
                                function getProductsPromise(thisPage) {
                                    var defer = self.$q.defer();
                                    var request = scope.getRequest(thisPage, self.itemsPerPage);
                                    defer.resolve(self.dataService.customMethodData("api/PurchaseOrder/Product/List/", "POST", request))
                                    return defer.promise;
                                }

                                function getProducts(item) {
                                    return function () {
                                        return getProductsPromise(item).then(function (res: any) {
                                            scope.products = scope.products.concat(res.data);
                                            scope.searchContext.purchaseOrder.lineItems = scope.products;
                                        });
                                    };
                                }

                                var pages = [];
                                for (var thisPage = 0; thisPage < totalPages; thisPage++) {
                                    pages.push(thisPage);
                                }
                                
                                var chain = this.$q.when();
                                pages.forEach(function (el, thisPage) {
                                    chain = chain.then(getProducts(thisPage));
                                });
                                return chain;

                            }).finally(() => {
                                this.busyService.stop();
                            });      
                        //scope.items.initSearch(savedRequest, scope.searchFallbackCriteria);

                        // usage tracking
                        scope.trackUsage(Model.VerbEnum.SearchButtonClicked, scope.criteria);
                    }
                } else {
                    this.modalService.error("MESSAGE_INVALID_SEARCH");
                }
            }

            scope.isCloseWhenStatesUntruthySpecified = (): boolean => {
                return (scope.closeWhenStatesUntruthy != undefined) ? scope.closeWhenStatesUntruthy : true;
            }

            scope.areStatesUntruthy = (): boolean => {
                return !scope.criteria.includeActive && !scope.criteria.includeInactive && !scope.criteria.includeDeleted;
            }

            scope.clearAdvancedSearch = (): void => {
                scope.intelligentSearch = null;
                scope.initializeCriteria();
                scope.search();
            }

            scope.clearAdvancedSearchAndApply = (): void => {
                scope.initializeCriteria();
                scope.closeModal();
            }

            scope.initializeCriteria = (): void => {
                scope.criteria = {
                    includeActive: true,
                    view: scope.view
                };
                if (scope.isApplicationModeCO()) {
                    scope.criteria.coSearchType = CoSearchType.CentralOffice;
                    scope.criteria.maintenanceMode = true;
                }
            }

            /* END: Infinite Scroll Data Retrieval */

            scope.closeContext = (): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }

            scope.closeModal = (): void => {
                this.$mdDialog.cancel();
            }

            //scope.toggleCoMenu = (): void => {
            //    scope.showCo = !scope.showCo;
            //}

            scope.toggleFilter = (key, $event): void => {
                scope.criteria[key] = !scope.criteria[key];
                $event.stopPropagation();
                scope.search();
            }

            scope.toggleSearchFilter = ($event): void => {
                scope.intelligentSearch = '';
                $event.stopPropagation();
                scope.search();
            }

            scope.toggleDateFilter = ($event): void => {
                scope.criteria.startDate = null;
                scope.criteria.endDate = null;
                $event.stopPropagation();
                scope.search();
            }

            scope.assignFilterCriteria = (key, value): void => {
                scope.criteria[key] = value;
            }

            scope.trackUsage = (verb, payload): void => {
                let nounValue = Model.NounEnum[scope.noun];
                if (nounValue) {
                    let trackInfo: Model.TrackingItem = new Model.TrackingItem(Model.NounEnum[nounValue], verb, payload);
                    this.trackingService.saveTrackingInfo(trackInfo);
                }
            }

            scope.$watch(() => scope.coFilterBoolean, (newVal: boolean, oldVal: boolean) => {
                if (!angular.isUndefined(scope.coFilterBoolean))
                    scope.hideCoFilters = scope.coFilterBoolean;
            });


            scope.$watch(() => scope.addingItem, (newVal: any, oldVal: any) => {
                if (!angular.isUndefined(scope.addingItem))
                    scope.addItem(newVal || scope.addingitem);
            });

            scope.$watch(() => scope.items.loadedPages, (newVal: any, oldVal: any) => {
                if (!angular.isUndefined(scope.searchingAddsToExistingItems)) {
                    if (oldVal != null && oldVal.length != null) {
                        scope.newItems = oldVal;
                    }

                    if (!oldVal || !oldVal.length) {
                        setTimeout(function () {
                            scope.addNewIemsToRegularItems()
                        }, 200);
                    }
                }
            });

            scope.$watch(() => scope.isFirstSearch, (newVal: any, oldVal: any) => {
                if (!angular.isUndefined(scope.searchingAddsToExistingItems) && oldVal && !newVal) {
                    scope.newItems = null;
                }
            });

            scope.addItem = (item): void => {
                if (!item) return
                var loadedPageIndex = scope.searchContext.purchaseOrder.lineItems.length;
                if (loadedPageIndex > 0) {

                    var findItem = _.findWhere(scope.searchContext.purchaseOrder.lineItems, {
                        id: item.id,
                        productInventoryType: item.productInventoryType
                    });
                    if (findItem == null) {
                        scope.searchContext.purchaseOrder.lineItems.unshift(item);
                    }
                } else {
                    scope.searchContext.purchaseOrder.lineItems.push(item);
                }
            }

            scope.addNewIemsToRegularItems = (): void => {
                if (scope.newItems != null && scope.newItems != null) {// && !scope.newItems.length
                    var addItem = true;
                    for (var x = 0; x < scope.newItems.length; x++) {
                        
                        for (var i = 0; i < scope.items.length; i++) {
                            if (scope.items[i].id == scope.newItems[x].id) {
                                addItem = false;
                            }
                        }

                        if (addItem) {
                            scope.items.push(scope.newItems[x]);
                            break;
                        }
                    }
                }
                
                scope.$apply();
            }

            scope.resetItemAppending = (): void => {
                scope.newItems = null;
                scope.items = null;
            }

        }

        constructor(
            private $rootScope: angular.IRootScopeService,
            private $state: angular.ui.IStateService,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            private loggingService: Meevo.Components.Logging.ILoggingService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $mdDialog: ng.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private busyService: Meevo.Components.Busy.BusyService,
            private $q: angular.IQService,
            private $mdSidenav: any) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: angular.IRootScopeService,
                $state: angular.ui.IStateService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                trackingService: Meevo.Components.Tracking.ITrackingService,
                loggingService: Meevo.Components.Logging.ILoggingService,
                modalService: Meevo.Components.Modal.IModalService,
                $mdDialog: ng.material.IDialogService,
                $translate: angular.translate.ITranslateService,
                identityService: Meevo.Components.Common.IIdentityService,
                securityService: Meevo.Components.Common.ISecurityService,
                busyService: Meevo.Components.Busy.BusyService,
                $q: angular.IQService,
                $mdSidenav: any) => {
                return new InventoryMaintenanceFormSideBar($rootScope, $state, dataService, trackingService,
                    loggingService, modalService, $mdDialog, $translate, identityService, securityService, busyService, $q, $mdSidenav);
            }

            directive.$inject = ["$rootScope", "$state", "meevo.components.common.DataService",
                "meevo.components.tracking.TrackingService",
                "meevo.components.logging.LoggingService",
                "meevo.components.modal.ModalService", "$mdDialog", "$translate", "meevo.components.common.IdentityService",
                "meevo.components.common.SecurityService",
                "meevo.components.busy.BusyService",
                "$q", "$mdSidenav"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoInventoryMaintenanceFormSideBar", InventoryMaintenanceFormSideBar.factory());
}
